export default {
  // namespaced: true,
  state: {
    CandidateController: {
      selectJobId: null,
      onlyThisJob: null
    }
  },
  mutations: {
    SET_CANDIDATE_JOB_ID (store, id) {
      store.CandidateController.selectJobId = id
    },
    SET_ONLY_THIS_JOB (store, status) {
      store.CandidateController.onlyThisJob = status
    }
  },
  getters: {
    // getCandidateSelectedJob
    getCandidateSelectedJob: (store, getters) => {
      const jobId = store.CandidateController.selectJobId
      return getters['entities/jobs/query']().find(jobId)
    },
    // getCandidateOnlyThisJob
    getCandidateOnlyThisJob: (store, getters) => {
      return store.CandidateController.onlyThisJob
    }
  },
  actions: {
    /*
    setCandidatePlacement
    */
    setCandidateJobId ({commit, dispatch, getters, state}, jobId) {
      if (jobId) {
        dispatch('getJobById', jobId).then(() => {
          commit('SET_CANDIDATE_JOB_ID', jobId)
        })
      } else {
        commit('SET_CANDIDATE_JOB_ID', null)
      }
    },
    /*
    setOnlyThisJob
    */
    setOnlyThisJob ({commit, dispatch, getters, state}, status) {
      commit('SET_ONLY_THIS_JOB', status)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/CandidateController.js